/* jslint browser: true */
/* global window */
import React, { Component } from 'react';
import NavMenu from './NavMenu';
import '../../node_modules/font-awesome/css/font-awesome.min.css';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: 'undefined'
        };
    }
    componentWillMount() {
        if (window.localStorage.getItem('token') !== '' && window.localStorage.getItem('token') !== null) {
            this.setState({token: window.localStorage.getItem('token')});
        } else {
            this.setState({token: ''});
            if(window.location.pathname.includes("/login") === false) {
                window.location.href = '/login?c';
            }
        }
    }

    /**
     * Vide le token en local
     */
    logout() {
        window.localStorage.setItem('token', '');
        window.location.href = '/login';
    }

    login() {
        window.location.href = '/login';
    }

    render() {
        return (
            <header>
                <div className="logo-box">
                    <img src="/pictures/logo-header.png" alt="logo" />
                    <div className="user-status">
                        {this.state.token !== '' ? (
                            <button
                                style={{ marginTop: '0' }}
                                className="btn myBtn"
                                onClick={() => this.logout()}
                            >
                                Déconnexion
                            </button>
                        ) : (
                            <button
                                style={{ marginTop: '0' }}
                                className="btn myBtn"
                                onClick={() => this.login()}
                            >
                                Connexion
                            </button>
                        )}
                    </div>
                </div>
                {window.location.pathname.indexOf('login') !== -1 ? (
                    <div className="bar-menu">
                        <h3 className="bar-menu-title">
                            <center>Parcours personnalisé</center>
                        </h3>
                        {/* Affiche le bouton mon compte si et seulement si le user existe */
                        (
                            <p className="my-account">
                                Mon compte <i className="fa fa-user" />
                            </p>
                        ) && this.state.token !== ''}
                    </div>
                ) : (
                    <NavMenu />
                )}
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js